import * as React from "react";
import { useTranslation } from "react-i18next";
import { ContactListRendererProps } from ".";
import useSnackbarAlert from "../../../utils/snackbarHandlers";
import { BorderColor, Delete, Visibility } from '@mui/icons-material';
import { Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, LinearProgress, Tooltip } from '@mui/material';
import { GridCellParams, GridColDef, DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const ContactListRenderer: React.FC<ContactListRendererProps> = ({ contactUsData, totalCount, loading, paginationModel, setPaginationModel, setRefreshTable }) => {
  const { t } = useTranslation();
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
  const navigate = useNavigate();
  const [dialogBox, setDialogBox] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState();
  const [deleteContactName, setDeleteContactName] = React.useState();
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || 'http://18.217.95.31:8080';

  const handleDelete = React.useCallback((id: any) => {
    axios.delete(`${apiBaseURL}/api/contact/deleteContact?id=${id}`)
      .then((res: any) => {
        setDialogBox(false);
        setRefreshTable(Math.random());
        showSuccessMessage(t("contactDeletedSuccessMessage"));
      })
      .catch((error: Error) => showErrorMessage(error))
  }, []);

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Name',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: 'phoneNumber',
      headerName: 'Phone Number',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: 'businessName',
      headerName: 'Business Name',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: 'subject',
      headerName: 'Subject',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: 'message',
      headerName: 'Message',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      width: 200,
      renderCell: (params: GridCellParams) => {
        return (
          <ButtonGroup size="small" color="inherit" aria-label="group action buttons">
            <Tooltip title="View">
              <Button
                onClick={(e) => navigate(`/admin/contacts/view/${params.row.id}`)}
              >
                <Visibility fontSize="small" />
              </Button>
            </Tooltip>
            <Tooltip title="Edit">
              <Button
                onClick={(e) => navigate(`/admin/contacts/edit/${params.row.id}`)}
              >
                <BorderColor fontSize="small" />
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                onClick={() => {
                  setDialogBox(true);
                  setDeleteId(params.row.id);
                  setDeleteContactName(params.row.name)
                }}
              >
                <Delete fontSize="small" />
              </Button>
            </Tooltip>
          </ButtonGroup>
        );
      },
      flex: 1,
    },
  ];

  return (
    <>
      {!loading ?
        <Grid className="w-full" style={{
          marginTop: "1%",
          height: "585px",
        }}>
          <DataGrid
            rows={contactUsData}
            loading={loading}
            columns={columns}
            rowCount={totalCount}
            pageSizeOptions={[10, 20, 50, 100]}
            pagination
            paginationMode="server"
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            getRowId={(row: any) => row.id}
            disableColumnSelector
            disableRowSelectionOnClick
            sx={{
              '& .MuiDataGrid-main': {
                borderColor: "#DAA520",
              },
              '& .MuiDataGrid-columnHeader': {
                backgroundColor: "#F5F5E6",

              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,

              },
              '& .MuiDataGrid-row.Mui-odd': {
                backgroundColor: "#F5F5E6",
              }
            }}
            getRowClassName={(params) => {
              return params.id as number % 2 === 0 ? 'Mui-even' : 'Mui-odd'
            }
            }
            columnBuffer={0}
          /></Grid> : <LinearProgress />}
      <Dialog
        open={dialogBox}
        onClose={() => setDialogBox(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t('deleteContact')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('deleteContactConfirmation') + deleteContactName + "?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogBox(false)}>{t('disagree')}</Button>
          <Button onClick={() => handleDelete(deleteId)} autoFocus>
            {t('agree')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ContactListRenderer;
